<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="取自组织机构" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['companyCode']" placeholder="请输入取自组织机构"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="甲方部门编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['paDeptCode']" placeholder="请输入甲方部门编码"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="养户编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['alert']" placeholder="请输入养户编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="品类编码,物种下一级，从数据字典选择（10 蛋禽 20 肉禽）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['breedClassCode']" placeholder="请输入品类编码,物种下一级，从数据字典选择（10 蛋禽 20 肉禽）"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.cooperationModel')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['cooperMode']" placeholder="请输入合作模式"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.batchNo')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['code']" :placeholder="$t('label.pleaseSelectBatchNo')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="禽苗成本 元/只" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['chickCost']" placeholder="请输入禽苗成本 元/只" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保证金单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['depositPrice']" placeholder="请输入保证金单价" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="实际入舍日期，入舍日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择实际入舍日期，入舍日期" v-decorator="['actHousingDate']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="均重（集蛋、称重 total_weight/qty)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['avgWeight']" placeholder="请输入均重（集蛋、称重 total_weight/qty)" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="合同数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['planBreedQty']" placeholder="请输入合同数量" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标准料肉比（标准）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdFeedMeatAvg']" placeholder="请输入标准料肉比（标准）" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="扩展字段1" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sex']" placeholder="请输入扩展字段1"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标准体重（标准）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdWeightAvg']" placeholder="请输入标准体重（标准）" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.feedingStage')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['feedingStage']" :placeholder="$t('label.pleaseEnterTheFeedingStage')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="nowDays" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['nowDays']" placeholder="请输入nowDays" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="remainingDays" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['remainingDays', validatorRules.remainingDays]" placeholder="请输入remainingDays" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="survivalRate" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['survivalRate']" placeholder="请输入survivalRate" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="remainingQty" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['remainingQty']" placeholder="请输入remainingQty" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="deadAmoy" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['deadAmoy']" placeholder="请输入deadAmoy" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="avgDaysWeight" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['avgDaysWeight']" placeholder="请输入avgDaysWeight" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="daysFeedConsume" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['daysFeedConsume']" placeholder="请输入daysFeedConsume" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="daysDrugCost" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['daysDrugCost']" placeholder="请输入daysDrugCost" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="daysVaccineCost" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['daysVaccineCost']" placeholder="请输入daysVaccineCost" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="countAllCost" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['countAllCost']" placeholder="请输入countAllCost" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="公司保本点" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['paBreakevenPoint']" placeholder="请输入公司保本点" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="每日价格" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['dailyPrice']" placeholder="请输入每日价格" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="养户保本点" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['pbBreakevenPoint']" placeholder="请输入养户保本点" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="priceDiff" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['priceDiff', validatorRules.priceDiff]" placeholder="请输入priceDiff" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="preProfit" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['preProfit']" placeholder="请输入preProfit"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="singleProfit" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['singleProfit']" placeholder="请输入singleProfit"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@comp/jeecg/JFormContainer'
  import JDate from '@comp/jeecg/JDate'

  export default {
    name: 'EfsStatementsGroupDailyForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          remainingDays: {
            rules: [
              { required: true, message: '请输入remainingDays!'},
            ]
          },
          priceDiff: {
            rules: [
              { required: true, message: '请输入priceDiff!'},
            ]
          },
        },
        url: {
          add: "/groupStatements/efsStatementsGroupDaily/add",
          edit: "/groupStatements/efsStatementsGroupDaily/edit",
          queryById: "/groupStatements/efsStatementsGroupDaily/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'companyCode','paDeptCode','farmerCode','breedClassCode','cooperMode','code','chickCost','depositPrice','actHousingDate','avgWeight','planBreedQty','stdFeedMeatAvg','sex','stdWeightAvg','feedingStage','nowDays','remainingDays','survivalRate','remainingQty','deadAmoy','avgDaysWeight','daysFeedConsume','daysDrugCost','daysVaccineCost','countAllCost','paBreakevenPoint','dailyPrice','pbBreakevenPoint','priceDiff','preProfit','singleProfit'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'companyCode','paDeptCode','farmerCode','breedClassCode','cooperMode','code','chickCost','depositPrice','actHousingDate','avgWeight','planBreedQty','stdFeedMeatAvg','sex','stdWeightAvg','feedingStage','nowDays','remainingDays','survivalRate','remainingQty','deadAmoy','avgDaysWeight','daysFeedConsume','daysDrugCost','daysVaccineCost','countAllCost','paBreakevenPoint','dailyPrice','pbBreakevenPoint','priceDiff','preProfit','singleProfit'))
      },
    }
  }
</script>